"use client";

import { YoutubeIcon } from "lucide-react";
import { ThemeName, EXPAND_BTN_DARK } from "./theme";

const YoutubeExpandBtn = ({
  variant = "dark",
  theme = "blue",
}: {
  variant?: "light" | "dark";
  theme?: Exclude<ThemeName, "white">;
}) => {
  const isLight = variant === "light";
  return (
    <a
      href="https://www.youtube.com/@Dose-Of-Growth"
      className={`group inline-flex w-[160px] cursor-pointer items-center justify-center gap-2 rounded-lg border py-2 font-onest text-sm font-normal transition-all duration-300 hover:gap-1 lg:w-[200px] lg:gap-3 lg:rounded-xl lg:py-2.5 lg:text-base lg:hover:gap-2 3xl:w-[240px] 3xl:gap-5 3xl:rounded-[18px] 3xl:py-3 3xl:text-[20px] 3xl:hover:gap-3 ${
        isLight
          ? "border-white font-medium text-white"
          : EXPAND_BTN_DARK[theme]
      }`}
    >
        <YoutubeIcon />
      <span>Go to Youtube</span>
    </a>
  );
};

export default YoutubeExpandBtn;
